import React, {createContext, useState} from 'react';

export const DataContext = createContext();


export function ContextSearchUserProvider ({children}) {

    const [openEdit, setOpenEdit] = useState(false);
    const [idVacancie, setIdVacancie] = useState('');
    const [contractSalary, setContractSalary] = useState(false);

    return (
        <DataContext.Provider value={{openEdit, setOpenEdit, idVacancie, setIdVacancie, contractSalary, setContractSalary}} >
            {children}
        </DataContext.Provider>
    )
}


